import {
  Box,
  FormHelperText,
  MenuItem,
  Select as MUISelect,
} from '@mui/material';
import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';

const Select = forwardRef(
  // eslint-disable-next-line arrow-body-style
  ({ name, helperText, options, overwriteProps = {}, ...props }, ref) => {
    const children = [{ label: 'Please select', value: '' }, ...options].map(
      option => (
        <MenuItem
          key={option.value}
          value={option?.value}
          disabled={Boolean(option.disabled)}>
          {option.label}
        </MenuItem>
      ),
    );

    return (
      <Box sx={{ mt: '-5px' }}>
        <Controller
          defaultValue=""
          name={name}
          render={({ field, fieldState: { error: fsError } }) => {
            return (
              <Box>
                <MUISelect
                  displayEmpty
                  defaultValue=""
                  size="small"
                  fullWidth
                  value={field?.value ?? ''}
                  {...field}
                  {...props}
                  error={Boolean(fsError?.message)}
                  ref={ref}
                  inputProps={{}}
                  {...overwriteProps}>
                  {children}
                </MUISelect>
                {fsError || helperText ? (
                  <FormHelperText
                    sx={{ typography: 'body2' }}
                    error={Boolean(fsError)}>
                    {fsError?.message || helperText}
                  </FormHelperText>
                ) : null}
              </Box>
            );
          }}
        />
      </Box>
    );
  },
);

export default Select;
